<template>
  <div v-if="isValidArray(categories)" class="categories">
    <span v-for="category in categories" :key="category.value">
      <v-tooltip slot="append" max-width="177" top>
        <div
          class="label-category"
          :class="{ 'label-category--disabled': category.percentage === 0 }"
          slot="activator"
        >
          <img :src="category.img" :alt="category.text">
          <span>{{ category.text }}</span>
          <strong>{{ category.percentage | formatPercentage }}</strong>
        </div>

        <span>{{ category.tooltip }}</span>
      </v-tooltip>
    </span>
  </div>
</template>

<script>
import { isArray } from 'utils/functions'

export default {
  name: 'Categories',
  props: {
    categories: {
      type: Array
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.categories {
  border-bottom: solid 1px $gray-2;
  border-top: solid 1px $gray-2;
  margin-top: 8px;
  padding: 1px 16px 10px;
  text-align: center;
}
</style>
